export default __webpack_public_path__ + "images/0072c37593461bafc257409d51310dc2.png";